import { imageMock } from '@mock/schema/components/shared/image.mock';
import { kitchenImplantationMock } from '@mock/schema/components/shared/kitchen-implantation.mock';
import { KitchenLight } from '@shared/models';

export const kitchenLightMock: KitchenLight = {
  id: '7031',
  name: 'Smart',
  implantation: kitchenImplantationMock,
  price: `2 816 €`,
  ecoPart: `23,25 €`,
  image: imageMock,
  url: '/mock-modeles/smart',
};
